import { Context } from '@alltrails/shared/types/context';
import usePathname from 'hooks/usePathname';
import { Page } from 'components/shared/Page/Page';
import Router from '@alltrails/shared/components/ReactRouter';
import PressContent from './PressContent';

type PressProps = {
  context: Context;
};

const Press = ({ context }: PressProps) => {
  const fullpath = usePathname();

  return (
    <div>
      <Page context={context}>
        <Router fullpath={fullpath}>
          <PressContent />
        </Router>
      </Page>
    </div>
  );
};

export default Press;
